import { render } from "./AutomationLanding.vue?vue&type=template&id=601d26de&scoped=true"
import script from "./AutomationLanding.vue?vue&type=script&lang=js"
export * from "./AutomationLanding.vue?vue&type=script&lang=js"

import "./AutomationLanding.vue?vue&type=style&index=0&id=601d26de&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601d26de"]])

export default __exports__